module.exports = __webpack_public_path__ + "img/81.d816c59b.png";